import React from 'react';
import { Module } from 'shared/services/prisma/types';

import { Alert, Button } from 'antd';
import { Link } from 'react-router-dom';
import SurveysCard from '../Survey/SurveysCard';
import AnalyticsCard from '../Analytics/AnalyticsCard';
import HsrCard from '../Hsr/HsrCard';

const Website = ({ dataSourceId, notCollecting }) => (
  <>
    {notCollecting && (
      <Alert
        type="warning"
        showIcon
        message="This website has not sent any data recently, make sure the script is installed correctly."
        action={<Link to={`/data-sources/${dataSourceId}/settings/script`}><Button>View script instructions</Button></Link>}
      />
    )}
    <AnalyticsCard />
    <HsrCard />
    <SurveysCard module={Module.UxSurveys} />
  </>
);

export default Website;
